"use strict";

var _objectWithoutProperties = require("/opt/build/repo/site/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
var _toConsumableArray = require("/opt/build/repo/site/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _regeneratorRuntime = require("/opt/build/repo/site/node_modules/@babel/runtime/regenerator/index.js");
var _defineProperty = require("/opt/build/repo/site/node_modules/@babel/runtime/helpers/defineProperty.js");
var _asyncToGenerator = require("/opt/build/repo/site/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var _excluded = ["vibeIntersection"];
require("core-js/modules/es.object.from-entries.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var Axios = require("axios"),
  axiosRetry = require("axios-retry"),
  querystring = require("querystring"),
  dayjs = require("dayjs"),
  dayjsRecur = require("dayjs-recur"),
  isBetween = require("dayjs/plugin/isBetween"),
  LinearScale = require("linear-scale"),
  truncate = require("truncate"),
  turf = require("@turf/helpers"),
  turf_distance = require("@turf/distance"),
  turf_boolean = require("@turf/boolean-point-in-polygon"),
  constants = require("./constants.js"),
  map = require("./map.js"),
  vibes = require("./vibes.js"),
  wordpress = require("./wordpress.js");
function _interopDefaultLegacy(e) {
  return e && "object" == typeof e && "default" in e ? e : {
    default: e
  };
}
function _interopNamespace(a) {
  if (a && a.__esModule) return a;
  var r = Object.create(null);
  return a && Object.keys(a).forEach(function (e) {
    var t;
    "default" !== e && (t = Object.getOwnPropertyDescriptor(a, e), Object.defineProperty(r, e, t.get ? t : {
      enumerable: !0,
      get: function get() {
        return a[e];
      }
    }));
  }), r.default = a, Object.freeze(r);
}
require("@mapbox/geo-viewport"), require("@turf/meta"), require("@turf/clusters"), require("@turf/bbox-polygon"), require("@turf/center"), require("@turf/truncate"), require("@turf/clusters-dbscan"), require("@turf/points-within-polygon"), require("@turf/rhumb-bearing"), require("@turf/rhumb-distance"), require("@turf/rhumb-destination"), require("fuse.js");
var Axios__default = _interopDefaultLegacy(Axios),
  axiosRetry__default = _interopDefaultLegacy(axiosRetry),
  querystring__default = _interopDefaultLegacy(querystring),
  dayjs__default = _interopDefaultLegacy(dayjs),
  dayjsRecur__default = _interopDefaultLegacy(dayjsRecur),
  isBetween__default = _interopDefaultLegacy(isBetween),
  LinearScale__default = _interopDefaultLegacy(LinearScale),
  truncate__default = _interopDefaultLegacy(truncate),
  turf__namespace = _interopNamespace(turf),
  turf_distance__default = _interopDefaultLegacy(turf_distance),
  turf_boolean__default = _interopDefaultLegacy(turf_boolean),
  badges = [{
    slug: "check-in-challenge-foster-powell",
    status: "publish",
    vibe: [],
    badge_family: [],
    key: "check-in-challenge-foster-powell",
    description: "",
    has_location: !0,
    icon: {
      url: "https://vibemap.wpengine.com/wp-content/uploads/2020/08/no_image_placeholder.png",
      icon: "https://vibemap.wpengine.com/wp-includes/images/media/default.png"
    },
    name: "Check in Challenge Foster Powell",
    location: {
      ID: 1441,
      post_title: "Portland",
      post_name: "portland"
    }
  }, {
    slug: "downtown-challenge-chicago",
    status: "publish",
    vibe: [],
    badge_family: [],
    key: "downtown-challenge-chicago",
    description: "<p>Explore Downtown Chicago and Win Prizes.</p>\n",
    has_location: !0,
    icon: {
      url: "https://vibemap.wpengine.com/wp-content/uploads/2023/09/Downtown-Chicago-Challenge_Badge-04.png",
      icon: "https://vibemap.wpengine.com/wp-includes/images/media/default.png"
    },
    name: "Downtown Challenge Chicago",
    location: {
      ID: 38148,
      post_title: "Chicago",
      post_name: "chicago"
    }
  }, {
    slug: "downtown-portland-summer-challenge",
    status: "publish",
    vibe: [],
    badge_family: [],
    key: "downtown-portland-summer-challenge",
    description: "<p>Unlock prizes and embrace local adventures while you explore Downtown Portland this summer.</p>\n",
    has_location: !0,
    map: {
      address: "Downtown Portland, Portland, OR, USA",
      lat: 45.5173454,
      lng: -122.6835562,
      city: "Portland",
      name: "Portland Downtown",
      zoom: 14
    },
    icon: {
      url: "https://vibemap.wpengine.com/wp-content/uploads/2020/06/Vibemap_City_Portland-17.jpg",
      icon: "https://vibemap.wpengine.com/wp-includes/images/media/default.png"
    },
    name: "Downtown Portland Summer Challenge",
    location: {
      ID: 1441,
      post_title: "Portland",
      post_name: "portland"
    }
  }, {
    slug: "downtown-oakland-summer-challenge",
    status: "publish",
    vibe: [],
    badge_family: [],
    key: "downtown-oakland-summer-challenge",
    description: "<p>Unlock prizes and embrace local adventures while you explore Downtown Oakland this summer. This challenge runs now through August 21st, 2023!</p>\n",
    has_location: !0,
    map: {
      address: "Oakland, CA, USA",
      lat: 37.8043514,
      lng: -122.2711639,
      city: "Oakland",
      name: "Oakland",
      zoom: 14
    },
    icon: {
      url: "https://vibemap.wpengine.com/wp-content/uploads/2023/05/Downtown-Oakland-Challenge_Badge-01-3.jpg",
      icon: "https://vibemap.wpengine.com/wp-includes/images/media/default.png"
    },
    name: "Downtown Oakland Summer Challenge",
    location: {
      ID: 1447,
      post_title: "Oakland",
      post_name: "oakland"
    }
  }, {
    slug: "art-about-town-treasure-hunt-general",
    status: "publish",
    vibe: [],
    badge_family: [],
    key: "art-about-town-treasure-hunt-general",
    description: "<p>Grab your map, don your artistic spirit, and let the exploration begin!</p>\n",
    has_location: !0,
    icon: {
      url: "https://vibemap.wpengine.com/wp-content/uploads/2023/05/Art-About-Town-Treasure-Hunt-Badge-Vibemap-Small.jpg",
      icon: "https://vibemap.wpengine.com/wp-includes/images/media/default.png"
    },
    name: "Art About Town Treasure Hunt ",
    location: {
      ID: 1447,
      post_title: "Oakland",
      post_name: "oakland"
    }
  }, {
    slug: "art-about-town-treasure-hunt-2",
    status: "publish",
    vibe: [],
    badge_family: [],
    key: "art-about-town-treasure-hunt-2",
    description: "<p>Grab your map, don your artistic spirit, and let the exploration begin!</p>\n",
    has_location: !0,
    icon: {
      url: "https://vibemap.wpengine.com/wp-content/uploads/2023/05/Art-About-Town-Treasure-Hunt-Badge-East-Bay-Small.jpg",
      icon: "https://vibemap.wpengine.com/wp-includes/images/media/default.png"
    },
    name: "Art About Town Treasure Hunt East Bay",
    location: {
      ID: 1447,
      post_title: "Oakland",
      post_name: "oakland"
    }
  }, {
    slug: "art-about-town-treasure-hunt-berkeley",
    status: "publish",
    vibe: [],
    badge_family: [],
    key: "art-about-town-treasure-hunt-berkeley",
    description: "<p>Grab your map, don your artistic spirit, and let the exploration begin!</p>\n",
    has_location: !0,
    icon: {
      url: "https://vibemap.wpengine.com/wp-content/uploads/2023/05/Art-About-Town-Treasure-Hunt-Badge-Berkeley-Small.jpg",
      icon: "https://vibemap.wpengine.com/wp-includes/images/media/default.png"
    },
    name: "Art About Town Treasure Hunt Berkeley",
    location: {
      ID: 1447,
      post_title: "Oakland",
      post_name: "oakland"
    }
  }, {
    slug: "art-about-town-treasure-hunt",
    status: "publish",
    vibe: [],
    badge_family: [],
    key: "art-about-town-treasure-hunt",
    description: "<p>Grab your map, don your artistic spirit, and let the exploration begin!</p>\n",
    has_location: !0,
    icon: {
      url: "https://vibemap.wpengine.com/wp-content/uploads/2023/05/Art-About-Town-Treasure-Hunt-Badge-Oakland-Small.jpg",
      icon: "https://vibemap.wpengine.com/wp-includes/images/media/default.png"
    },
    name: "Art About Town Treasure Hunt Oakland",
    location: {
      ID: 1447,
      post_title: "Oakland",
      post_name: "oakland"
    }
  }, {
    slug: "56132",
    status: "publish",
    vibe: [],
    badge_family: [],
    key: "56132",
    description: "<p>Explore Downtown San Jose and Win Prizes.</p>\n",
    has_location: !0,
    icon: {
      url: "https://vibemap.wpengine.com/wp-content/uploads/2023/03/50932693_10161385073470364_2256098350099070976_n.jpg",
      icon: "https://vibemap.wpengine.com/wp-includes/images/media/default.png"
    },
    name: "San Jose Downtown Challenge",
    location: {
      ID: 55524,
      post_title: "San Jose",
      post_name: "san-jose"
    }
  }, {
    slug: "open-peoria",
    status: "publish",
    vibe: [],
    badge_family: [],
    key: "open-peoria",
    description: "<p>Check in with Vibemap once to enter the Open Peoria Challenge and earn a FREE Vibemap mug.</p>\n<p>&nbsp;</p>\n<p>Check in five times to be entered into a raffle to win a special Discover Peoria Vibemap prize!</p>\n<p>&nbsp;</p>\n<p>Pick up your free mug from Noah on Tuesday at the Peoria Civic Center.</p>\n",
    has_location: !0,
    icon: {
      url: "https://vibemap.wpengine.com/wp-content/uploads/2023/01/Discover-Peoria.jpg",
      icon: "https://vibemap.wpengine.com/wp-includes/images/media/default.png"
    },
    name: "Open Peoria",
    location: {
      ID: 52306,
      post_title: "Peoria",
      post_name: "peoria"
    }
  }],
  badges$1 = {
    badges: badges
  };
axiosRetry__default.default(Axios__default.default, {
  retries: 3,
  retryDelay: axiosRetry__default.default.exponentialDelay,
  onRetry: function onRetry(e, t, a) {
    console.log("Axios retrying: ", e, t, a);
  }
});
var axios = Axios__default.default,
  jsonpack = (dayjs__default.default.extend(isBetween__default.default), dayjs__default.default.extend(dayjsRecur__default.default), require("jsonpack"));
exports.activityCategories = {};
var categories_flat = [];
exports.cities = [], exports.neighborhoods = [];
var getAPIDomain = function getAPIDomain() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return function (e) {
      var t = "undefined" != typeof process && process.env.API_ENV,
        e = e || t || "production";
      return "production" === e ? "https://api.vibemap.com" : "staging" === e ? "https://staging.api.vibemap.com" : "http://localhost:9000";
    }(e);
  },
  api_domain = getAPIDomain(),
  api_version = "v0.3",
  useSearchAPI = !0,
  useSearchAPIEvents = !0,
  ApiUrl = "".concat(api_domain, "/").concat(api_version, "/"),
  filterList = function filterList() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [{
      test: "test",
      value: "foo"
    }, {
      test: "test",
      value: "bar"
    }];
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "food";
    var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "value";
    var r = new RegExp(t.replace(/[-[\]{}()*+!<=:?.\/\\^$|#\s,]/g, "\\$&"), "i");
    return e.filter(function (e) {
      return function (e) {
        return r.test(e[a]);
      }(e);
    });
  },
  getRandomItem = function getRandomItem(e) {
    return e[Math.floor(Math.random() * e.length)];
  },
  encodeCardIndex = function encodeCardIndex(e, t) {
    return e + t / 10;
  },
  matchLists = function matchLists(e, t) {
    var a = 0;
    return a = 0 < e.length && 0 < t.length ? e.filter(function (e) {
      return t.includes(e);
    }).length : a;
  },
  rankVibes = function rankVibes(e, a) {
    var t = [];
    return (t = e.map(function (e) {
      var t = 0;
      return t = a.includes(e) ? a.length - a.indexOf(e) : t;
    })).reduce(function (e, t) {
      return e + t;
    }, 0) / a.length;
  },
  sortByKey = function sortByKey(e, t) {
    return console.log("sortByKey (a, b)", e, t), e;
  },
  sortByPopularity = function sortByPopularity(e, t) {
    e = parseInt(e.details.msv || 2);
    return parseInt(t.details.msv || 2) - e;
  };
try {
  var V = require("../dist/activityCategories.zip.json");
  exports.activityCategories = {
    activityCategories: jsonpack.unpack(V)
  }, categories_flat = exports.activityCategories.activityCategories.sort(sortByPopularity).map(function (e) {
    return e.name.toLowerCase();
  });
} catch (e) {
  console.log("Error with packed activityCategories ", e);
}
try {
  var Y = require("../dist/cities.zip.json"),
    Z = (exports.cities = jsonpack.unpack(Y), require("../dist/neighborhoods.zip.json"));
  exports.neighborhoods = jsonpack.unpack(Z);
} catch (e) {
  console.log("Error with packed cities or neighborhoods ", e);
}
var sortByArray = function sortByArray(e, a) {
    return e.sort(function (e, t) {
      return a.indexOf(e) - a.indexOf(t);
    });
  },
  isClosedToday = function isClosedToday(e) {
    return "00:00:00" === e.opens && "00:00:00" === e.closes;
  },
  displayHours = function displayHours(a) {
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "dd";
    var t = isOpen(a),
      r = a.find(function (_ref) {
        var e = _ref.day_of_week;
        return 8 === e;
      });
    if (t.openEveryday) {
      var e = [];
      t = dayjs__default.default(t.opens).format("ha") + "-" + dayjs__default.default(t.closes).format("ha"), t = (e.push(t), a.find(function (e) {
        return "POPULAR" == e.name;
      }));
      return console.log("Popular at: ", t), e;
    }
    var s = 0,
      i = [];
    for (; s < 7;) {
      var _e = a.filter(function (e) {
          return e.day_of_week == s;
        }),
        _t = (a.find(function (e) {
          return e.day_of_week == s && "POPULAR" == e.name;
        }), !1);
      if (void 0 !== _e && (_t = isClosedToday(_e)), void 0 === _e || _t) {
        if (_t || void 0 === r) i.push({
          day_of_week: s,
          closed: !0
        });else {
          var _e2 = Object.assign({}, r);
          _e2.day_of_week = s, i.push(_e2), console.log("DEBUG: updated ordered hours ", i, _e2);
        }
      } else _e.closed = !1, i.push(_e);
      s++;
    }
    var n = function n(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Mon";
      var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      return function (e, t) {
        var r = e.opens.split(":"),
          e = e.closes.split(":"),
          s = "00" !== r[1] || "00" !== e[1],
          t = dayjs__default.default().day(t).format(o),
          s = s ? "h:mma" : "ha",
          r = dayjs__default.default().hour(r[0]).minute(r[1]).format(s),
          e = dayjs__default.default().hour(e[0]).minute(e[1]).format(s);
        return a ? t + " " + r + "-" + e : r + "-" + e;
      }(e, t);
    };
    return i.map(function (t) {
      var a = t[0],
        r = (a.day_of_week + 1) % 7;
      if (!0 === a.closed) return dayjs__default.default().day(r).format(o) + ": Closed";
      {
        var _e3 = n(a, r);
        return 1 < t.length && (a = t[1], t = n(a, r, !1), _e3 += "; " + t), _e3;
      }
    });
  },
  isOpen = function isOpen(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : dayjs__default.default();
    return function (e) {
      var a = t.day();
      var r = t.format("YYYY-MM-DD");
      if (t.hour(), !e) return {
        openNow: !1,
        openToday: !1,
        isPopular: !1
      };
      var s = e.find(function (_ref2) {
        var e = _ref2.day_of_week;
        return e === a;
      });
      var o = e.find(function (_ref3) {
          var e = _ref3.day_of_week;
          return 8 === e;
        }),
        e = e.filter(function (e) {
          return isClosedToday(e);
        }),
        e = void 0 !== o && 0 == e.length;
      if (s = void 0 === s ? o : s) {
        var i = dayjs__default.default(r + " " + s.opens),
          n = dayjs__default.default(r + " " + s.closes);
        o = t.isBetween(i, n), r = o && "POPULAR" === s.name;
        return i.format("ha"), n.format("ha"), {
          openNow: o,
          openToday: !0,
          openEveryday: e,
          opens: i,
          closes: n,
          isPopular: r
        };
      }
      return {
        openNow: !1,
        openToday: !1,
        openEveryday: !1,
        isPopular: !1
      };
    }(e);
  },
  parseDateTime = function parseDateTime(e) {
    return e ? dayjs__default.default(e) : null;
  },
  formatDateTime = function formatDateTime(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    var r, s, o;
    return e ? (r = (e = "string" == typeof e ? parseDateTime(e) : e).format("MMM"), s = e.format("D"), o = e.format("ddd"), "".concat(a ? o : null, " ").concat(r, " ").concat(s, " ") + e.format("ha")) : null;
  },
  getCardOptions = function getCardOptions(t) {
    var _t$singCards$posts$ = t.singCards.posts[0],
      e = _t$singCards$posts$.categoryQuery,
      a = _t$singCards$posts$.distanceQuery,
      r = _t$singCards$posts$.geoQuery,
      s = _t$singCards$posts$.searchQuery,
      o = _t$singCards$posts$.vibeQuery;
    t.overrideQuery && t.overrideQuery.vibe && (o = t.overrideQuery.vibe), t.overrideQuery && t.overrideQuery.cities && 0 < t.overrideQuery.cities.length && (i = exports.cities.filter(function (e) {
      return e.slug === t.overrideQuery.cities[0];
    }), r = r || i[0].location, a = a || 7), t.overrideQuery && t.overrideQuery.location && (r = t.overrideQuery.location, a = t.overrideQuery.distance || a), r || (i = exports.cities.filter(function (e) {
      return "oakland" === e.slug;
    }), r = i[0].location);
    var i = (o = "string" == typeof o ? o.replace(/\s/g, "").split(",") : o) ? o.map(function (e) {
      return "string" == typeof e ? e : e.slug;
    }) : [];
    return {
      category: e,
      distance: a,
      point: r.longitude + "," + r.latitude,
      ordering: "vibe",
      search: s,
      vibes: i
    };
  },
  getAPIParams = function getAPIParams(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 150;
    var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : useSearchAPI;
    return function (t) {
      var s = e.activity,
        o = e.distance,
        i = e.point,
        n = e.tags,
        l = e.vibes,
        c = Object.assign({}, e),
        u = 1;
      0 < o && (u = Math.round(o * constants.METERS_PER_MILE)), c.ordering = e.ordering || "-aggregate_rating", c.per_page = t;
      var t = i.split(","),
        g = t[1],
        t = t[0];
      return r && (c.activity && (c.categories = s), c.tags && 0 < c.tags.length && (c["tags.raw__wildcard"] = "*".concat(n, "*"), delete c.tags), c.vibes && (c.vibes = l, delete c.vibes), c.category && (c.categories = "string" == typeof c.category ? c.category.toLowerCase().split() : c.category), c.distance && (c.location__geo_distance = u + "m__".concat(g, "__") + t, delete c.distance), (c.start_date || c.start_date_after) && (r = c.start_date || c.start_date_after, g = dayjs__default.default(r).startOf("day").format("YYYY-MM-DDTHH:mm:ss"), c.start_date__gte = g, delete c.start_date, delete c.start_date_after), (c.end_date || c.end_date_before) && (t = c.end_date || c.end_date_before, r = dayjs__default.default(t).endOf("day").format("YYYY-MM-DDTHH:mm:ss"), c.start_date__lte = r, delete c.end_date, delete c.end_date_before), c.search && 0 < c.search.length && ("east bay open studios".includes(c.search) && (c.editorial_category = "EastBayOpenStudios"), delete c.ordering, delete c[":vibes.raw__in"]), c.editorial_category && (g = c.editorial_category, c["editorial_categories.raw__wildcard"] = "*".concat(g, "*"), delete c.editorial_category), c.is_approved = e.is_approved || !1, c.is_chain = e.is_chain || !1, c.is_closed = e.is_closed || !1, c.is_destination = e.is_destination || !1, c.city && (c["city.raw__contains"] = c.city, delete c.city)), "all" !== s && null !== s && (c.category = s), c.dist = u, delete c.activity, delete c.distance, delete c.bounds, null == c.city && delete c.city, null != c.category && "all" != c.category && 0 != c.category.length || delete c.category, null == c.editorial_category && delete c.editorial_category, null == c.search && delete c.search, null != c.vibes && 0 != c.vibes.length || delete c.vibes, 0 == a && delete c.relatedVibes, c;
    }(t);
  },
  getCategoryMatch = function getCategoryMatch() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ["all"];
    var t = exports.activityCategories.activityCategories.map(function (e) {
      return e.slug;
    });
    var a = [];
    return e.map(function (e) {
      return t.includes(e) && a.push(e), !0;
    }), a;
  },
  getFullLink = function getFullLink(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "instagram";
    if (null === e || "" === e) return null;
    var a = r.parse(e);
    var r = new URL(e);
    e = a.path.replace("/", "");
    return {
      instagram: "https://instagram.com/",
      twitter: "https://twitter.com/",
      facebook: "https://facebook.com/"
    }[t] + e;
  },
  geLocationFromCity = function geLocationFromCity(e) {
    return e.cityDetails ? e.cityDetails.placemarker : e.location || null;
  },
  getMax = function getMax(e, t) {
    var a = 0;
    return e.forEach(function (e) {
      e = e.properties[t];
      e > a && (a = e);
    }), a;
  },
  getMin = function getMin(e, t) {
    var a = 100;
    return e.forEach(function (e) {
      e = e.properties[t];
      e < a && (a = e);
    }), a;
  },
  getTimeOfDay = function getTimeOfDay(e) {
    if (e && e.isValid()) return e = parseFloat(e.format("HH")), 12 <= e && e <= 17 ? "afternoon" : 17 <= e ? "evening" : "morning";
  },
  getTopLocations = function getTopLocations(e) {
    var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "city";
    var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    var r = {};
    e.map(function (e) {
      var t = e.properties[a];
      return null != t && "null" != t && (e = t.split(",")[0], r.hasOwnProperty(t) ? r[e] += 1 : r[e] = 1), null;
    });
    var s,
      o = [];
    for (s in r) o.push([s, r[s]]);
    var i = o.sort(function (e, t) {
      return t[1] - e[1];
    });
    return t ? i.map(function (e) {
      return e[0];
    }) : i;
  },
  getTopTags = function getTopTags(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    var a = {};
    e.map(function (e) {
      return e.properties.tags.map(function (e) {
        return a.hasOwnProperty(e) ? a[e] += 1 : a[e] = 1, null;
      }), null;
    });
    var r,
      s = [];
    for (r in a) s.push([r, a[r]]);
    var o = s.sort(function (e, t) {
      return t[1] - e[1];
    });
    return t ? o.map(function (e) {
      return e[0];
    }) : o;
  },
  getTopVibes = function getTopVibes(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    var a = {};
    e.map(function (e) {
      return e.properties.vibes.map(function (e) {
        return a.hasOwnProperty(e) ? a[e] += 1 : a[e] = 1, null;
      }), null;
    });
    var r,
      s = [];
    for (r in a) s.push([r, a[r]]);
    var o = s.sort(function (e, t) {
      return t[1] - e[1];
    });
    return t ? o.map(function (e) {
      return e[0];
    }) : o;
  },
  getTopCategories = function getTopCategories(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "categories";
    var a = {};
    e.map(function (e) {
      return e.properties[t].map(function (e) {
        return a.hasOwnProperty(e) ? a[e] += 1 : a[e] = 1, null;
      }), null;
    });
    var r,
      s = [];
    for (r in a) s.push([r, a[r]]);
    return s.sort(function (e, t) {
      return t[1] - e[1];
    });
  },
  getWaveFromVibe = function getWaveFromVibe(e) {
    return "buzzing" !== e ? "medium" : "high";
  },
  graphToEvents = function graphToEvents() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return e.map(function (e) {
      e = e.node;
      var t = e.groupDetails;
      var a = t.name,
        r = t.link,
        e = e.slug,
        s = t.description,
        o = t.image ? t.image.url : null,
        o = [{
          url: o,
          original: o
        }],
        i = t.map,
        n = t.price || "free",
        l = t.vibes ? t.vibes.map(function (e) {
          return e.slug;
        }) : [],
        c = (t.recurring, t.recurrence),
        u = t.which,
        g = t.day.value,
        p = t.startTime || "00:00",
        d = t.startTime ? t.endTime : "00:00";
      var _ = nextDateFromRecurring(c, g, u);
      c = dayjs__default.default(_.next(1).toLocaleString().replace("00:00:00", p)), g = dayjs__default.default(_.next(1).toLocaleString().replace("00:00:00", d));
      return {
        id: e,
        title: a,
        geometry: {
          type: "Point",
          coordinates: [-122.26747099999956, 37.81396520000001]
        },
        dateTime: c,
        image: o,
        card_type: "event",
        properties: {
          name: a,
          title: a,
          url: r,
          address: i && i.streetAddress,
          categories: [],
          city: t.cities && t.cities[0].slug,
          description: s,
          is_online: !1,
          images: [],
          hotspots_place: i,
          location: i,
          start_date: c,
          end_date: g,
          vibemap_images: o,
          likes: 10,
          price: n,
          recurs: !0,
          vibes: l
        }
      };
    });
  },
  groupsToEvents = function groupsToEvents() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return e.map(function (e) {
      var t = e.acf;
      var a = t.name,
        r = t.link,
        e = e.slug,
        s = t.description,
        o = t.image && t.image.url,
        o = o ? [{
          url: o,
          original: o
        }] : [],
        i = t.map,
        n = t.price || "free",
        l = t.vibes ? t.vibes.map(function (e) {
          return e.slug;
        }) : [],
        c = (t.recurring, t.recurrence),
        u = t.which,
        g = t.day && t.day.label ? t.day.label : "sunday",
        p = t.start_time || "00:00",
        d = t.end_time || "00:00";
      var _ = nextDateFromRecurring(c, g, u),
        m = dayjs__default.default(_.next(1).toLocaleString().replace("00:00:00", p)),
        A = dayjs__default.default(_.next(1).toLocaleString().replace("00:00:00", d));
      return {
        id: e,
        title: a,
        geometry: {
          type: "Point",
          coordinates: [-122.26747099999956, 37.81396520000001]
        },
        dateTime: m.toISOString(),
        image: o,
        card_type: "event",
        properties: {
          name: a,
          title: a,
          url: r,
          address: i && i.streetAddress,
          categories: [],
          city: t.cities && t.cities[0].slug,
          description: s,
          is_online: !1,
          images: o,
          hotspots_place: i,
          location: i,
          start_date: m.toISOString(),
          end_date: A.toISOString(),
          vibemap_images: o,
          likes: 10,
          price: n,
          recurs: !0,
          vibes: l
        }
      };
    });
  },
  normalize = function normalize(e, t, a) {
    return (e - t) / (a - t) * 10;
  },
  normalize_all = function normalize_all() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 10;
    var o = LinearScale__default.default().domain([t, a]).range([r, s]);
    return o(e);
  },
  scaleIconSize = function scaleIconSize() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    var r = LinearScale__default.default().domain([t, a]).range([1, 5]);
    return r(e);
  },
  scaleMarker = function scaleMarker() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
    var t = arguments.length > 1 ? arguments[1] : undefined;
    var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 14;
    return function (r) {
      isNaN(e) && (e = 3.5);
      var s = LinearScale__default.default().domain([8, 20]).range([10, 30]);
      var r = s(r),
        o = 3 * r;
      var i = LinearScale__default.default().domain([0, a]).range([r, o]);
      return Math.round(i(e));
    }(r);
  },
  scaleDensityArea = function scaleDensityArea() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var t = arguments.length > 1 ? arguments[1] : undefined;
    var a = LinearScale__default.default().domain([1, 60, 1e3]).range([0, .8, 1]);
    return a(e);
  },
  scaleDensityBonus = function scaleDensityBonus(e) {
    var t = LinearScale__default.default().domain([0, 1]).range([2 * constants.HEATMAP_INTENSITY, constants.HEATMAP_INTENSITY]);
    return t(e);
  },
  scaleScore = function scaleScore() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
    var t = LinearScale__default.default().domain([0, 5]).range([60, 100]);
    return Math.round(t(e));
  },
  scaleSelectedMarker = function scaleSelectedMarker(e) {
    var t = LinearScale__default.default().domain([8, 12, 20]).range([.1, 1.2, 4]);
    return Math.round(t(e));
  },
  getDatesFromRange = function getDatesFromRange() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "weekend";
    var t = dayjs__default.default().startOf("day");
    var a = t.day() + 1;
    var r = 0,
      s = 0;
    switch (e) {
      case "day":
        s = 1;
        break;
      case "weekend":
        s = 7 - a;
        break;
      case "next_week":
        r = 8 - a, s = 7;
        break;
      case "month":
        var o = t.endOf("month");
        s = o.diff(t, "day");
        break;
      case "quarter":
        s = 90;
    }
    return {
      start: t.add(r, "day").startOf("day"),
      end: t.add(s, "day").endOf("day")
    };
  },
  getEventOptions = function getEventOptions() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "oakland";
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "quarter";
    var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var o = arguments.length > 5 ? arguments[5] : undefined;
    var i = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
    var n = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
    var l = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
    var c = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 1;
    return function (e) {
      var u = exports.cities.concat(exports.neighborhoods);
      var g = u.filter(function (e) {
          return e.slug === t;
        }),
        g = g && 0 < g.length ? g[0].location : exports.cities[0],
        e = getDatesFromRange(e);
      var p = n ? dayjs__default.default(n) : e.start,
        d = l ? dayjs__default.default(l) : e.end;
      n = p.format("YYYY-MM-DD HH:mm");
      var _ = {
        activity: r,
        category: r,
        distance: a,
        point: g.longitude + "," + g.latitude,
        ordering: "-score_combined",
        start_date_after: n,
        end_date_before: d.format("YYYY-MM-DD HH:mm"),
        page: c,
        search: o,
        tags: i,
        vibes: s
      };
      return null != _.category && "all" != _.category && 0 != _.category.length || delete _.category, null == _.search && delete _.search, null != _.tags && 0 != _.tags.length || delete _.tags, null != _.vibes && 0 != _.vibes.length || delete _.vibes, _;
    }(e);
  },
  fetchEvents = function fetchEvents() {
    try {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        distance: 20,
        page: 1,
        point: "-122.269994,37.806507"
      };
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t) {
          var _e4, r, s, o, i, n, l, c, u;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _e4 = e, r = _e4.category, s = _e4.days, o = _e4.point, i = _e4.search;
                n = o.split(",").map(function (e) {
                  return parseFloat(e);
                }), n = map.getLocationFromPoint(n), t = (dayjs__default.default().startOf("day").format("YYYY-MM-DD HH:MM"), dayjs__default.default().add(s, "days").format("YYYY-MM-DD HH:MM"), t && r && (e.search = "".concat(r || "", " ") + (i || "")), map.sortLocations(exports.cities, n)), n = t && 0 < t.length ? t[0].name : null, t = module.exports.getAPIParams(e, void 0, void 0, useSearchAPIEvents), e = querystring__default.default.stringify(t), t = ApiUrl + "search/events", l = axios.CancelToken.source();
                _context.next = 4;
                return axios.get(t + "?" + e, {
                  cancelToken: l.token
                }).catch(function (e) {
                  return console.log("Axios error ", e.response && e.response.statusText), {
                    data: [],
                    count: 0,
                    top_categories: [],
                    top_locations: [],
                    top_tags: [],
                    top_vibes: [],
                    loading: !1,
                    timedOut: !1
                  };
                });
              case 4:
                c = _context.sent;
                if (!a) {
                  _context.next = 11;
                  break;
                }
                _context.next = 8;
                return wordpress.getGroups({
                  city: n || ""
                });
              case 8:
                t = _context.sent;
                u = groupsToEvents(t.data);
                c.data.results.features = u.concat(c.data.results.features);
              case 11:
                e = c.data.results.features, l = getTopCategories(e), a = getTopTags(e), n = getTopVibes(e), t = getTopLocations(e), console.log("DEBUG: top_categories", l), e = _objectSpread(_objectSpread({}, c), {}, {
                  count: c.data.count,
                  top_categories: l,
                  top_locations: t,
                  top_tags: a,
                  top_vibes: n,
                  loading: !1,
                  timedOut: !1
                });
                return _context.abrupt("return", e);
              case 13:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x, _x2) {
          return _ref4.apply(this, arguments);
        };
      }()(e, t);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  nextDateFromRecurring = function nextDateFromRecurring() {
    for (var _len = arguments.length, _ref5 = new Array(_len), _key = 0; _key < _len; _key++) {
      _ref5[_key] = arguments[_key];
    }
    var e = _ref5[0],
      t = _ref5[1],
      a = _ref5[2];
    var r = dayjs__default.default();
    a = ["first", "second", "third", "fourth", "fifth"].indexOf(a), a = 0 < a ? a : 0;
    return "monthly" == e ? r.recur().every(t).daysOfWeek().every([a]).weeksOfMonthByDay() : r.recur().every(t).daysOfWeek();
  },
  fetchPlacesDetails = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var t,
        a,
        r,
        _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            t = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : "place";
            a = axios.CancelToken.source();
            if (!("event" == t && (r = ApiUrl + "events/"), r = "place" == t ? ApiUrl + "places/" : r)) {
              _context2.next = 6;
              break;
            }
            _context2.next = 5;
            return axios.get("" + r + e, {
              cancelToken: a.token
            }).catch(function (e) {
              return console.log("axios error ", e && e.statusText), null;
            });
          case 5:
            return _context2.abrupt("return", _context2.sent);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function fetchPlacesDetails(_x3) {
      return _ref6.apply(this, arguments);
    };
  }(),
  fetchPlacePicks = function fetchPlacePicks() {
    try {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        distance: 5,
        point: "-123.1058197,49.2801149",
        ordering: "-score_combined",
        tags: [],
        vibes: ["chill"],
        preferredVibes: [],
        relatedVibes: []
      };
      return function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(t) {
          var _t2, e, a, r, s, o, i, n, _t2$useNearest, l, c, u, g, p, d, y, _, m, A, _e5, f, h;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _t2 = t, e = _t2.activity, a = _t2.ordering, r = _t2.per_page, s = _t2.point, o = _t2.vibes, i = _t2.preferredVibes, n = _t2.relatedVibes, _t2$useNearest = _t2.useNearest, l = _t2$useNearest === void 0 ? !1 : _t2$useNearest;
                c = r || 400;
                u = o && 0 < o.length, g = s.split(",").map(function (e) {
                  return parseFloat(e);
                }), p = map.getLocationFromPoint(g), d = map.sortLocations(exports.cities, p), p = map.distanceBetweenLocations(d[0].location, p);
                if (l && p < 20) {
                  y = d[0];
                  t.point = y.centerpoint.join(",");
                }
                _ = ApiUrl + "search/places", m = axios.CancelToken.source();
                A = {};
                p = /*#__PURE__*/function () {
                  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
                    var t;
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) switch (_context3.prev = _context3.next) {
                        case 0:
                          e = getAPIParams(e, c);
                          t = querystring__default.default.stringify(e);
                          _context3.next = 4;
                          return axios.get(_ + "?" + t, {
                            cancelToken: m.token
                          }).catch(function (e) {
                            return console.log("axios error ", e.response && e.response.statusText), {
                              data: [],
                              count: 0,
                              query: "?" + t,
                              top_vibes: null,
                              loading: !1,
                              timedOut: !1
                            };
                          });
                        case 4:
                          return _context3.abrupt("return", A = _context3.sent);
                        case 5:
                        case "end":
                          return _context3.stop();
                      }
                    }, _callee3);
                  }));
                  return function p(_x5) {
                    return _ref8.apply(this, arguments);
                  };
                }();
                _context4.next = 9;
                return p(t);
              case 9:
                d = (A = _context4.sent).data.count;
                if (!(0 == d && u)) {
                  _context4.next = 17;
                  break;
                }
                _e5 = Object.assign({}, t);
                _e5.search = o[0];
                _e5.vibes = [];
                _context4.next = 16;
                return p(_e5);
              case 16:
                A = _context4.sent;
              case 17:
                u = A.data && A.data.results && A.data.results.features ? A.data.results.features : [], p = formatPlaces(u);
                f = o || [];
                u = f.concat(i || []), h = _objectSpread(_objectSpread({}, t), {}, {
                  relatedVibes: n
                }), g = scorePlaces(p, g, u, ["aggregate_rating", "vibes", "distance", "offers", "hours"], a, !(!t || !t.shouldShuffle) && t.shouldShuffle, h), u = getTopCategories(p), t = getTopTags(p), h = getTopVibes(p);
                return _context4.abrupt("return", {
                  data: g,
                  count: d,
                  top_categories: u,
                  top_locations: getTopLocations(p),
                  top_tags: t,
                  top_vibes: h,
                  loading: !1,
                  timedOut: !1
                });
              case 21:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x4) {
          return _ref7.apply(this, arguments);
        };
      }()(t);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  fetchPlacesFromSearch = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e) {
      var t;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            t = new URLSearchParams([["query", ""], ["latitude", e.latitude], ["longitude", e.longitude]]);
            _context5.next = 3;
            return axios.get("https://dev.vibemap.com/search_places?" + t.toString()).catch(function (e) {
              return console.log("axios error ", e.response && e.response.statusText), {
                data: [],
                count: 0,
                query: "?",
                top_vibes: null,
                loading: !1,
                timedOut: !1
              };
            });
          case 3:
            return _context5.abrupt("return", _context5.sent);
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function fetchPlacesFromSearch(_x6) {
      return _ref9.apply(this, arguments);
    };
  }(),
  fetchPlacesFromIds = function fetchPlacesFromIds() {
    try {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ["740b43a4-3925-4413-9414-fff9d8d16932", "c8262c66-1a83-4d4b-a3e6-8710864ffd1f"];
      return function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
          var t;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                t = ApiUrl + "/search/places";
                params = new URLSearchParams([["ids", e.join("__")]]);
                _context6.next = 4;
                return axios.get(t + "?" + params.toString()).catch(function (e) {
                  return console.log("axios error ", e.response && e.response.statusText), {
                    data: [],
                    error: e,
                    count: 0,
                    query: "?" + params,
                    top_vibes: null,
                    loading: !1,
                    timedOut: !1
                  };
                });
              case 4:
                e = _context6.sent;
                t = e.data.count;
                return _context6.abrupt("return", {
                  data: e.data && e.data.results && e.data.results.features ? e.data.results.features : [],
                  count: t,
                  loading: !1,
                  timedOut: !1
                });
              case 7:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        return function (_x7) {
          return _ref10.apply(this, arguments);
        };
      }()(e);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  decodePlaces = function decodePlaces(e) {
    return e.map(function (e) {
      return e.properties.vibes = JSON.parse(e.properties.vibes), e.properties.subcategories = JSON.parse(e.properties.subcategories), e.properties.categories = JSON.parse(e.properties.categories), e.properties.vibemap_images = [], e.properties.images = [e.properties.thumbnail_url], null != e.properties.opening_hours && (e.properties.opening_hours = JSON.parse(e.properties.opening_hours)), delete e.properties.tips, delete e.properties.facebook, delete e.properties.telephone, delete e.properties.website, e;
    });
  },
  formatPlaces = function formatPlaces() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var s = categories_flat,
      o = vibes.getCategoriesByLevel(2).map(function (e) {
        return e.slug;
      });
    return console.log("DEBUG why are there dots for categories besdie these ", o), e.map(function (e) {
      if (!e) return null;
      var t = e.properties;
      t.place_type = "places", t.short_name = truncate__default.default(t.name, constants.TRUCATE_LENGTH), t.aggregate_rating = parseFloat(t.aggregate_rating), null == t.aggregate_rating_count && (t.aggregate_rating_count = 1), t.num_vibes = t.vibes.length, t.sub_categories = t.sub_categories, t.top_vibe = null;
      var a = t.categories.map(function (e) {
          return (e = "Drink" == e ? "Drinking" : e).toLowerCase();
        }).filter(function (e) {
          return o.includes(e.toLowerCase());
        }),
        a = sortByArray(a, s),
        r = (void 0 !== t.categories && 0 !== t.categories.length || (t.categories = ["place"]), a[0] || "dot");
      return t.icon = a[0] ? "icon_".concat(r, "_light") : r, t.cluster = null, "dot" == r && console.log("DEBUG missing icon dot: ", t.name, t.categories), e.properties = t, e;
    }).filter(Boolean);
  },
  vibesFromPlaces = function vibesFromPlaces(e) {
    return [];
  },
  getRecommendedVibes = function getRecommendedVibes(e) {
    return [];
  },
  scorePlaces = function scorePlaces(e, c) {
    var u = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var g = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ["vibes", "aggregate_rating", "distance"];
    var t = arguments.length > 4 ? arguments[4] : undefined;
    var a = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !0;
    var r = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 12;
    var p = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
    var d = {};
    var _ = {};
    g.map(function (e) {
      return d[e] = 1e-5;
    }), g.map(function (e) {
      return _[e] = 1 / 0;
    });
    r = r <= 10 ? 10 : r, r = normalize_all(r, 10, 20, 0, 10);
    var o = {
      category: 0,
      vibe: 10,
      distance: 8 / (1 + 7 * Math.pow(Math.exp(1), -.7 * r)),
      rating: 4,
      hours: 0,
      offers: 0
    };
    "relevance" !== t && (o[t] += 3);
    var s = e.map(function (e) {
      var _isOpen;
      var a = e.properties;
      if (a.stats = {}, g.includes("vibes")) {
        var _e6 = 0,
          _t3 = 0;
        void (a.vibes_score = 0) === a.vibes && (a.vibes = ["chill"]);
        var s = 0 < a.vibes.length ? 2 * Math.log10(a.vibes.length) : 0;
        0 < a.vibes.length && (a.vibes_score = s), a.images && 0 < a.images.length && (_t3 += 0 < a.images.length ? 2 * Math.log10(a.images.length) : 0), u && 0 < u.length && a.vibes && (s = 10 * (_e6 = matchLists(u, a.vibes)) + 2 * (p.relatedVibes ? matchLists(p.relatedVibes, a.vibes) : 0), r = +rankVibes(u, a.vibes), _t3 += s + r, a.vibes_score += _t3, a.stats.num_vibes = a.vibes.length, a.stats.num_matching_vibes = _e6, a.stats.vibe_match_score = s, a.stats.vibe_order_score = r), a.vibes_score > d.vibes && (d.vibes = a.vibes_score), a.vibes_score < _.vibes && (_.vibes = a.vibes_score), a.stats.total_vibe_score = a.vibes_score;
      }
      if (g.includes("categories")) {
        s = [0][0];
        a.categories_score = 0;
        var _n = a.categories.concat(a.subcategories),
          _l = _n.filter(function (e, t) {
            return _n.indexOf(e) == t;
          });
        if (0 < a.categories.length && (a.categories_score = a.categories.length), 0 < u.length) {
          var _r = [];
          _l.forEach(function (t) {
            var e = constants.place_sub_categories.filter(function (e) {
                return e.main_category.includes(t);
              }),
              a = constants.place_sub_categories.filter(function (e) {
                return e.name.includes(t);
              });
            0 < e.length && (_r = _r.concat(e[0].vibes)), 0 < a.length && (_r = _r.concat(a[0].vibes));
          });
          s = matchLists(u, _r);
          a.categories_score += 10 * s;
        }
        a.categories_score > d.categories && (d.categories = a.categories_score), a.categories_score < _.categories && (_.categories = a.categories_score);
      }
      var r, t, o, i;
      return g.includes("likes") && (a.likes > d.likes && (d.likes = a.likes), a.likes < _.likes && (_.likes = a.likes)), g.includes("distance") && (r = turf__namespace.point(e.geometry ? e.geometry.coordinates : [0, 0]), a.distance = turf_distance__default.default(c, r), a.distance > d.distance && (d.distance = a.distance), a.distance < _.distance && (_.distance = a.distance)), g.includes("aggregate_rating") && (a.aggregate_rating > d.aggregate_rating && (d.aggregate_rating = a.aggregate_rating), a.aggregate_rating < _.aggregate_rating && (_.aggregate_rating = a.aggregate_rating), null == _.aggregate_rating_count && (_.aggregate_rating_count = 1, d.aggregate_rating_count = 1), a.aggregate_rating_count > d.aggregate_rating_count && (d.aggregate_rating_count = a.aggregate_rating_count), a.aggregate_rating_count < _.aggregate_rating_count && (_.aggregate_rating_count = a.aggregate_rating_count)), a.offers_score = 0, a.hours_score = 0, g.includes("offers") && (a.offers && 0 < a.offers.length && (a.offers_score = 2), (_isOpen = isOpen(a.opening_hours), s = _isOpen.openNow, r = _isOpen.openToday, t = _isOpen.opens, o = _isOpen.closes, i = _isOpen.isPopular), a.open_now = s, a.popular_now = i, a.opens = t, a.closes = o, r && (a.hours_score += .5), s && (a.hours_score += .5), i && (a.hours_score += 5)), a.stats.hours_bonus = a.hours_score, e.properties = a, e;
    });
    var i = 0,
      n = 1 / 0,
      l = s.map(function (e) {
        var t = e.properties;
        g.includes("vibes") && (t.vibes_score = normalize_all(t.vibes_score, _.vibes, d.vibes, 0, 1), t.vibes_score = t.vibes_score * o.vibe), g.includes("categories") && (t.categories_score = normalize_all(t.categories_score, _.categories, d.categories, 0, 1), t.categories_score = t.categories_score * o.category), g.includes("likes") && (t.likes_score = normalize_all(t.likes, _.likes, d.likes, 0, 1)), g.includes("venue") && (t.venue_score = normalize_all(t.place_vibe_count, _.likplace_vibe_countes, d.place_vibe_count, 0, 1)), g.includes("aggregate_rating") && (s = normalize_all(t.aggregate_rating, _.aggregate_rating, d.aggregate_rating, 0, 1), a = normalize_all(t.aggregate_rating_count, _.aggregate_rating_count, d.aggregate_rating_count, 0, 1), t.aggregate_rating_score = (s + a) / 2, t.aggregate_rating_score *= o.rating, t.stats.aggregate_rating_score = t.aggregate_rating_score), g.includes("distance") && (s = d.distance, t.distance_score = 1 - normalize_all(t.distance, _.distance, s, 0, .95), t.distance_score *= o.distance, t.stats.distance_score = t.distance_score), g.includes("hours") && (t.hours_score *= o.hours);
        var a = g;
        var r = g.map(function (e) {
          return t[e + "_score"];
        });
        var s = r.indexOf(Math.max.apply(null, r));
        return r.indexOf(Math.min.apply(null, r)), t.average_score = r.reduce(function (e, t) {
          return e + t;
        }, 0) / r.length, t.average_score > i && (i = t.average_score), t.average_score < n && (n = t.average_score), t.reason = a[s], e.properties = t, e;
      });
    var m = l.sort(function (e, t) {
      return t.properties.average_score - e.properties.average_score;
    });
    r = m.map(function (e) {
      var t = e.properties;
      return t.average_score = normalize_all(t.average_score, n, i, .65, 1), t.icon_size = scaleIconSize(t.average_score, .65, 1), t.stats.final_score_normalized = t.average_score, e;
    }), t = r.length;
    return a && 100 < t ? module.exports.shuffleTopPicks(r) : r;
  },
  reducePlaceProperties = function reducePlaceProperties(e) {
    var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ["name", "url", "address", "categories", "subcategories", "neighborhood", "price", "short_description", "vibemap_images", "vibes"];
    return e.map(function (t) {
      return t.properties = Object.fromEntries(a.map(function (e) {
        return [e, t.properties[e]];
      })), t;
    });
  },
  shuffleTopPicks = function shuffleTopPicks(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    var a = e.slice(0, t).map(function (e) {
      return {
        value: e,
        sort: Math.random()
      };
    }).sort(function (e, t) {
      return e.sort - t.sort;
    }).map(function (_ref11) {
      var e = _ref11.value;
      return e;
    });
    e = e.slice(t);
    return a.concat(e);
  },
  toTitleCase = function toTitleCase(e) {
    if ("string" != typeof e) return e;
    e = e.toLowerCase().split(" ");
    for (var t = 0; t < e.length; t++) e[t] = e[t].charAt(0).toUpperCase() + e[t].slice(1);
    return e.join(" ");
  },
  nearest_places = function nearest_places(e, r) {
    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
    return function (e) {
      var o = [],
        e = (e.map(function (e) {
          var t = e.properties;
          var a = turf__namespace.point(e.geometry.coordinates);
          t.distance = turf_distance__default.default(r, a), t.distance < s && o.push(e);
        }), o.slice(0));
      return e.sort(function (e, t) {
        return e.properties.distance - t.properties.distance;
      }), e;
    }(e);
  },
  validate_check_in = function validate_check_in(e, t) {
    var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .5;
    e = turf__namespace.point(e.geometry.coordinates);
    return turf_distance__default.default(t, e) < a;
  },
  in_jls = function in_jls(e) {
    var t = turf__namespace.polygon([[[-122.282617, 37.802862], [-122.2643, 37.795721], [-122.265502, 37.787005], [-122.288139, 37.796077], [-122.282617, 37.802862]]]);
    return turf_boolean__default.default(e, t);
  },
  in_neighborhood = function in_neighborhood(a) {
    var r = [],
      s = [],
      o = turf__namespace.point(a.geometry.coordinates);
    return exports.neighborhoods.map(function (e) {
      var t = turf_distance__default.default([e.map.lng, e.map.lat], o);
      (t < 5 && in_bbox_helper(a.geometry.coordinates, e.boundary) || 1e-5 < e.radius && t < e.radius || t < .8) && (r.push(e.id), s.push(e.slug));
    }), r;
  },
  in_bbox_helper = function in_bbox_helper(e, t) {
    return "" !== t && void 0 !== t && (t = JSON.parse(t), t = turf__namespace.polygon([t]), turf_boolean__default.default(e, t));
  },
  nearest_neighborhood = function nearest_neighborhood(t) {
    var e = exports.neighborhoods.map(function (e) {
      return {
        name: e.name,
        neigh_dist: turf_distance__default.default([e.map.lng, e.map.lat], t)
      };
    });
    return e.sort(function (e, t) {
      return e.neigh_dist - t.neigh_dist;
    }), e.slice(0, 10);
  },
  challenge_badges_lookup = function challenge_badges_lookup() {
    var t = [];
    return badges$1.badges.map(function (e) {
      "neighborhood" == e.type && t.push(e);
    }), t;
  },
  associate_badge = function associate_badge(a) {
    var e = challenge_badges_lookup(),
      r = [];
    return e.map(function (t) {
      console.log(t);
      for (var _e7 = 0; _e7 < a.length; _e7++) t.location.ID == a[_e7] && r.push(t);
    }), r;
  },
  searchCities = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var e,
        t,
        _args7 = arguments;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            e = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : "";
            e = "https://dev.vibemap.com/search_locations/?city=" + e;
            _context7.next = 4;
            return axios.get(e).catch(function (e) {
              return console.log("error ", e), {
                error: !0,
                data: e
              };
            });
          case 4:
            t = _context7.sent;
            return _context7.abrupt("return", t.data.map(function (t) {
              var e = exports.cities.find(function (e) {
                return e.name.includes(t.name);
              });
              if (e && map.distanceBetweenLocations(t.location, e.location) < 10) return e;
              return exports.neighborhoods.find(function (e) {
                return e.name.toLowerCase().includes(t.name.toLowerCase());
              }), t;
            }));
          case 6:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function searchCities() {
      return _ref12.apply(this, arguments);
    };
  }(),
  searchTags = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var e,
        _args8 = arguments;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            e = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : "art";
            e = ApiUrl + "/tags/?" + e;
            _context8.next = 4;
            return axios.get(e).catch(function (e) {
              return console.log("error ", e), {
                error: !0,
                data: e
              };
            });
          case 4:
            return _context8.abrupt("return", _context8.sent.data);
          case 5:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function searchTags() {
      return _ref13.apply(this, arguments);
    };
  }(),
  getAllBoundaries = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var e,
        _args9 = arguments;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            e = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : "both";
            e = "https://api.vibemap.com/v0.3/boundaries/?admin_level=".concat(e, "&include_hidden=1&per_page=100&random=") + Math.random();
            console.log("DEBUG getAllBoundaries endpoint ", e);
            _context9.next = 5;
            return axios.get(e).catch(function (e) {
              return console.log("error ", e), {
                error: !0,
                data: []
              };
            });
          case 5:
            e = _context9.sent;
            return _context9.abrupt("return", e.data);
          case 7:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function getAllBoundaries() {
      return _ref14.apply(this, arguments);
    };
  }(),
  getBoundary = /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var e,
        _args10 = arguments;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            e = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : "chicago";
            e = "https://api.vibemap.com/v0.3/boundaries/?admin_level=both&slug=" + e;
            _context10.next = 4;
            return axios.get(e).catch(function (e) {
              console.log("error ", e);
            });
          case 4:
            e = _context10.sent;
            if (!(!e || !e.data)) {
              _context10.next = 7;
              break;
            }
            return _context10.abrupt("return", null);
          case 7:
            _context10.prev = 7;
            return _context10.abrupt("return", e.data.results[0] || null);
          case 11:
            _context10.prev = 11;
            _context10.t0 = _context10["catch"](7);
            return _context10.abrupt("return", (console.log("Problem with boundary data ", _context10.t0), null));
          case 14:
          case "end":
            return _context10.stop();
        }
      }, _callee10, null, [[7, 11]]);
    }));
    return function getBoundary() {
      return _ref15.apply(this, arguments);
    };
  }(),
  searchPlacesByName = /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(e, t) {
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            e = {
              ordering: "name",
              category: e.category || "",
              per_page: e.perPage || 50,
              search: e.search || "",
              vibes: e.vibes || "",
              zoom: e.zoom || ""
            };
            t = t + "/search/places/?" + new URLSearchParams(e).toString();
            _context11.next = 4;
            return axios.get(t).catch(function (e) {
              return console.log("axios error ", e.response && e.response.statusText), [];
            });
          case 4:
            e = _context11.sent;
            return _context11.abrupt("return", e.data ? e.data.results.features : []);
          case 6:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return function searchPlacesByName(_x8, _x9) {
      return _ref16.apply(this, arguments);
    };
  }(),
  suggestPlacesByName = /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(e) {
      var t,
        a,
        r,
        s,
        o,
        i,
        n,
        l,
        _args12 = arguments;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            t = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : ApiUrl;
            a = _args12.length > 2 && _args12[2] !== undefined ? _args12[2] : !1;
            r = _args12.length > 3 && _args12[3] !== undefined ? _args12[3] : null;
            s = _args12.length > 4 && _args12[4] !== undefined ? _args12[4] : null;
            o = _args12.length > 5 && _args12[5] !== undefined ? _args12[5] : null;
            i = _args12.length > 6 && _args12[6] !== undefined ? _args12[6] : "places";
            n = null !== r & null !== s & a ? r.toString() + "__" + s.toString() : null;
            n = o & a ? n + "__".concat(o.toString(), "km") : n;
            r = a ? t + "/".concat(i, "/suggest/?name_suggest_context=").concat(e, "&name_suggest_loc=") + n : t + "/".concat(i, "/suggest/?name_suggest__completion=") + e;
            _context12.next = 11;
            return axios.get(r).catch(function (e) {
              return console.log("axios error ", e.response && e.response.statusText), [];
            });
          case 11:
            l = _context12.sent;
            console.log("HELPERS suggestPlacesByName results: ", l.data);
            return _context12.abrupt("return", l.data ? a ? l.data.name_suggest_context[0].options.map(function (e) {
              return e._source;
            }) : l.data.name_suggest__completion[0].options.map(function (e) {
              return e._source;
            }) : []);
          case 14:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    return function suggestPlacesByName(_x10) {
      return _ref17.apply(this, arguments);
    };
  }(),
  sortNeighborhoodsByVibes = function sortNeighborhoodsByVibes(e, t) {
    if (0 === t.length) return e;
    var a = vibes.getRelatedVibes(t);
    var s = _toConsumableArray(new Set([].concat(_toConsumableArray(t), _toConsumableArray(a)))),
      r = e.map(function (e) {
        var t = e.vibes || e.acf.vibes,
          a = t.map(function (_ref18) {
            var e = _ref18.slug;
            return e;
          });
        var r = s.filter(function (e) {
          return a.includes(e);
        }).length;
        return _objectSpread(_objectSpread({}, e), {}, {
          vibeIntersection: r
        });
      }),
      o = r.sort(function (e, t) {
        return t.vibeIntersection - e.vibeIntersection;
      });
    return o.map(function (e) {
      var t = e.vibeIntersection,
        a = _objectWithoutProperties(e, _excluded);
      return a;
    });
  },
  uploadImageKit = /*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref19) {
      var _ref19$domain, e, _ref19$file_path, t, _ref19$image_data, a;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            _ref19$domain = _ref19.domain, e = _ref19$domain === void 0 ? "https://vibemap.com" : _ref19$domain, _ref19$file_path = _ref19.file_path, t = _ref19$file_path === void 0 ? null : _ref19$file_path, _ref19$image_data = _ref19.image_data, a = _ref19$image_data === void 0 ? "data:image/gif;base64,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" : _ref19$image_data;
            a = {
              base64: a,
              path: t
            };
            _context13.next = 4;
            return axios.post(e + "/.netlify/functions/upload", JSON.stringify(a));
          case 4:
            t = _context13.sent;
            return _context13.abrupt("return", t && 200 == t.status && t.data ? t.data.image : null);
          case 6:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }));
    return function uploadImageKit(_x11) {
      return _ref20.apply(this, arguments);
    };
  }(),
  uploadVibemapImage = /*#__PURE__*/function () {
    var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref21) {
      var e, t, _ref21$filename, a, _ref21$title, r, s, o, i, n;
      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            e = _ref21.hotspots_place_id, t = _ref21.id, _ref21$filename = _ref21.filename, a = _ref21$filename === void 0 ? "image_generic" : _ref21$filename, _ref21$title = _ref21.title, r = _ref21$title === void 0 ? "Image from User" : _ref21$title, s = _ref21.size, o = _ref21.src, i = _ref21.url;
            _context14.prev = 1;
            n = {
              hotspots_place_id: e,
              id: t,
              filename: a,
              title: r,
              size: s,
              src: o,
              url: i
            };
            _context14.next = 5;
            return axios.post(ApiUrl + "images/places/", n);
          case 5:
            _context14.t0 = _context14.sent;
            return _context14.abrupt("return", {
              status: "success",
              data: _context14.t0
            });
          case 9:
            _context14.prev = 9;
            _context14.t1 = _context14["catch"](1);
            return _context14.abrupt("return", {
              status: "error",
              error: _context14.t1
            });
          case 12:
          case "end":
            return _context14.stop();
        }
      }, _callee14, null, [[1, 9]]);
    }));
    return function uploadVibemapImage(_x12) {
      return _ref22.apply(this, arguments);
    };
  }();
exports.associate_badge = associate_badge, exports.challenge_badges_lookup = challenge_badges_lookup, exports.decodePlaces = decodePlaces, exports.displayHours = displayHours, exports.encodeCardIndex = encodeCardIndex, exports.fetchEvents = fetchEvents, exports.fetchPlacePicks = fetchPlacePicks, exports.fetchPlacesDetails = fetchPlacesDetails, exports.fetchPlacesFromIds = fetchPlacesFromIds, exports.fetchPlacesFromSearch = fetchPlacesFromSearch, exports.filterList = filterList, exports.formatDateTime = formatDateTime, exports.formatPlaces = formatPlaces, exports.geLocationFromCity = geLocationFromCity, exports.getAPIDomain = getAPIDomain, exports.getAPIParams = getAPIParams, exports.getAllBoundaries = getAllBoundaries, exports.getBoundary = getBoundary, exports.getCardOptions = getCardOptions, exports.getCategoryMatch = getCategoryMatch, exports.getDatesFromRange = getDatesFromRange, exports.getEventOptions = getEventOptions, exports.getFullLink = getFullLink, exports.getMax = getMax, exports.getMin = getMin, exports.getRandomItem = getRandomItem, exports.getRecommendedVibes = getRecommendedVibes, exports.getTimeOfDay = getTimeOfDay, exports.getTopCategories = getTopCategories, exports.getTopTags = getTopTags, exports.getTopVibes = getTopVibes, exports.getWaveFromVibe = getWaveFromVibe, exports.graphToEvents = graphToEvents, exports.groupsToEvents = groupsToEvents, exports.in_bbox_helper = in_bbox_helper, exports.in_jls = in_jls, exports.in_neighborhood = in_neighborhood, exports.isClosedToday = isClosedToday, exports.isOpen = isOpen, exports.matchLists = matchLists, exports.nearest_neighborhood = nearest_neighborhood, exports.nearest_places = nearest_places, exports.normalize = normalize, exports.normalize_all = normalize_all, exports.parseDateTime = parseDateTime, exports.rankVibes = rankVibes, exports.reducePlaceProperties = reducePlaceProperties, exports.scaleDensityArea = scaleDensityArea, exports.scaleDensityBonus = scaleDensityBonus, exports.scaleIconSize = scaleIconSize, exports.scaleMarker = scaleMarker, exports.scaleScore = scaleScore, exports.scaleSelectedMarker = scaleSelectedMarker, exports.scorePlaces = scorePlaces, exports.searchCities = searchCities, exports.searchPlacesByName = searchPlacesByName, exports.searchTags = searchTags, exports.shuffleTopPicks = shuffleTopPicks, exports.sortByArray = sortByArray, exports.sortByKey = sortByKey, exports.sortByPopularity = sortByPopularity, exports.sortNeighborhoodsByVibes = sortNeighborhoodsByVibes, exports.suggestPlacesByName = suggestPlacesByName, exports.toTitleCase = toTitleCase, exports.uploadImageKit = uploadImageKit, exports.uploadVibemapImage = uploadVibemapImage, exports.validate_check_in = validate_check_in, exports.vibesFromPlaces = vibesFromPlaces;